import { Module } from "vuex";
import { IActions, IGetters, IMutations, ISearchState } from "./search.type";

export const getters: IGetters = {
    // getId: (state) => {
    //     return state.sale?.id;
    // },
};

export const mutations: IMutations = {
    setKeyword: (state, payload) => {
        state.keyword = payload;
    },
    setAutoCompleteResult: (state, payload) => {
        state.autoCompleteList = payload;
    },
    setSearchResult: (state, payload) => {
        state.searchList = payload;
    },
    setShowAutoCompleteResult: (state, payload) => {
        state.showAutoCompleteResult = payload;
    },
    setShowSearchResult: (state, payload) => {
        state.showSearchResult = payload;
    }
    // setLoading: (state, payload) => {
    //     state.loading = payload;
    // },
    // setSale: (state, payload) => {
    //     state.sale = payload;
    // },
    // setCustomers: (state, payload) => {
    //     state.customers = payload;
    // }
};

export const actions: IActions = {
    async autoComplete(this, context, payload): Promise<void> {
        console.log("action: autoComplete");
        const res = await this.$services.search.autoComplete(payload);
        context.commit("setAutoCompleteResult", res);
    },
    async search(this, context, payload): Promise<void> {
        const res = await this.$services.search.search(payload);
        context.commit("setSearchResult", res);
    },
    // async syncSale(this, context, payload): Promise<void> {
    //     console.log("syncSale:", payload);
    //     try {
    //         context.commit("setLoading", true);
    //         const u = await this.$services.sales.syncSale(payload);
    //         context.commit("setSale", u.data());
    //         console.log(u.customerList());
    //         context.commit("setCustomers", u.customerList());
    //     } catch (error) {
    //         console.warn(error);
    //     } finally {
    //         context.commit("setLoading", false);
    //     }
    // },
};

const search: Module<ISearchState, ISearchState> = {
    namespaced: true,
    state: {
        keyword: "",
        autoCompleteList: [],
        searchList: [],
        showAutoCompleteResult: false,
        showSearchResult: false,
        // loading: true,
        // sale: undefined,
        // customers: []
    },
    getters,
    mutations,
    actions,
};

export default search;
